<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control">
          <label class="label">Name</label>
          <input :class="{'input': true, 'is-danger': errors.has('name'), 'is-disabled': inProgress}" type="text" name="name" id="name" placeholder="Name" v-model="provider.name" v-validate="'required'">
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </p>
        <p class="control">
          <label class="label">Social Reason</label>
          <input :class="{'input': true, 'is-danger': errors.has('social_reason'), 'is-disabled': inProgress}" type="text" name="social_reason" id="social_reason" placeholder="Social Reason" v-model="provider.social_reason">
          <span v-show="errors.has('social_reason')" class="help is-danger">{{ errors.first('social_reason') }}</span>
        </p>
        <p class="control">
          <label class="label">CNPJ</label>
          <input :class="{'input': true, 'is-danger': errors.has('cnpj'), 'is-disabled': inProgress}" type="text" name="cnpj" id="cnpj" placeholder="CNPJ" v-model="provider.cnpj">
          <span v-show="errors.has('cnpj')" class="help is-danger">{{ errors.first('cnpj') }}</span>
        </p>
        <p class="control">
          <label class="label">Municipal Inscription</label>
          <input :class="{'input': true, 'is-danger': errors.has('municipal_inscription'), 'is-disabled': inProgress}" type="text" name="municipal_inscription" id="municipal_inscription" placeholder="Municipal Inscription" v-model="provider.municipal_inscription">
          <span v-show="errors.has('municipal_inscription')" class="help is-danger">{{ errors.first('municipal_inscription') }}</span>
        </p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">City</label>
              <input :class="{'input': true, 'is-danger': errors.has('city'), 'is-disabled': inProgress}" type="text" name="city" id="city" placeholder="City" v-model="provider.city">
              <span v-show="errors.has('city')" class="help is-danger">{{ errors.first('city') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">State</label>
              <input :class="{'input': true, 'is-danger': errors.has('state'), 'is-disabled': inProgress}" type="text" name="state" id="state" placeholder="State" v-model="provider.state">
              <span v-show="errors.has('city')" class="help is-danger">{{ errors.first('city') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Country</label>
              <input :class="{'input': true, 'is-danger': errors.has('country'), 'is-disabled': inProgress}" type="text" name="country" id="country" placeholder="Country" v-model="provider.country">
              <span v-show="errors.has('country')" class="help is-danger">{{ errors.first('country') }}</span>
            </p>
          </div>
        </div>
        <p class="control">
          <label class="label">CEP</label>
          <input :class="{'input': true, 'is-danger': errors.has('cep'), 'is-disabled': inProgress}" type="cep" name="cep" id="cep" placeholder="CEP" v-model="provider.cep" @change="cep">
          <span v-show="errors.has('cep')" class="help is-danger">{{ errors.first('cep') }}</span>
        </p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Address</label>
              <input :class="{'input': true, 'is-danger': errors.has('address'), 'is-disabled': inProgress || cepProgress}" type="text" name="address" id="address" placeholder="Address" v-model="provider.address">
              <span v-show="errors.has('address')" class="help is-danger">{{ errors.first('address') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Address Number</label>
              <input :class="{'input': true, 'is-danger': errors.has('address_number'), 'is-disabled': inProgress || cepProgress}" type="text" name="address_number" id="address_number" placeholder="Address Number" v-model="provider.address_number">
              <span v-show="errors.has('address_number')" class="help is-danger">{{ errors.first('address_number') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Neighborhood</label>
              <input :class="{'input': true, 'is-danger': errors.has('address_neighborhood'), 'is-disabled': inProgress || cepProgress}" type="text" name="address_neighborhood" id="address_neighborhood" placeholder="Neighborhood" v-model="provider.address_neighborhood">
              <span v-show="errors.has('address_neighborhood')" class="help is-danger">{{ errors.first('address_neighborhood') }}</span>
            </p>
          </div>
        </div>
        <p class="control is-expanded">
          <label class="label">Address Complement</label>
          <input :class="{'input': true, 'is-danger': errors.has('address_complement'), 'is-disabled': inProgress}" type="text" name="address_complement" id="address_complement" placeholder="Address Complement" v-model="provider.address_complement">
          <span v-show="errors.has('address_complement')" class="help is-danger">{{ errors.first('address_complement') }}</span>
        </p>
        <p class="control">
          <label class="label">Timezone</label>
          <select name="timezone" id="timezone" class="is-fullwidth" v-model="provider.timezone">
            <option value="-12:00">(GMT -12:00) Eniwetok, Kwajalein</option>
            <option value="-11:00">(GMT -11:00) Midway Island, Samoa</option>
            <option value="-10:00">(GMT -10:00) Hawaii</option>
            <option value="-09:50">(GMT -9:30) Taiohae</option>
            <option value="-09:00">(GMT -9:00) Alaska</option>
            <option value="-08:00">(GMT -8:00) Pacific Time (US &amp; Canada)</option>
            <option value="-07:00">(GMT -7:00) Mountain Time (US &amp; Canada)</option>
            <option value="-06:00">(GMT -6:00) Central Time (US &amp; Canada), Mexico City</option>
            <option value="-05:00">(GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima</option>
            <option value="-04:50">(GMT -4:30) Caracas</option>
            <option value="-04:00">(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz</option>
            <option value="-03:50">(GMT -3:30) Newfoundland</option>
            <option value="-03:00">(GMT -3:00) Brazil, Buenos Aires, Georgetown</option>
            <option value="-02:00">(GMT -2:00) Mid-Atlantic</option>
            <option value="-01:00">(GMT -1:00) Azores, Cape Verde Islands</option>
            <option value="+00:00">(GMT) Western Europe Time, London, Lisbon, Casablanca</option>
            <option value="+01:00">(GMT +1:00) Brussels, Copenhagen, Madrid, Paris</option>
            <option value="+02:00">(GMT +2:00) Kaliningrad, South Africa</option>
            <option value="+03:00">(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg</option>
            <option value="+03:50">(GMT +3:30) Tehran</option>
            <option value="+04:00">(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi</option>
            <option value="+04:50">(GMT +4:30) Kabul</option>
            <option value="+05:00">(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent</option>
            <option value="+05:50">(GMT +5:30) Bombay, Calcutta, Madras, New Delhi</option>
            <option value="+05:75">(GMT +5:45) Kathmandu, Pokhara</option>
            <option value="+06:00">(GMT +6:00) Almaty, Dhaka, Colombo</option>
            <option value="+06:50">(GMT +6:30) Yangon, Mandalay</option>
            <option value="+07:00">(GMT +7:00) Bangkok, Hanoi, Jakarta</option>
            <option value="+08:00">(GMT +8:00) Beijing, Perth, Singapore, Hong Kong</option>
            <option value="+08:75">(GMT +8:45) Eucla</option>
            <option value="+09:00">(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk</option>
            <option value="+09:50">(GMT +9:30) Adelaide, Darwin</option>
            <option value="+10:00">(GMT +10:00) Eastern Australia, Guam, Vladivostok</option>
            <option value="+10:50">(GMT +10:30) Lord Howe Island</option>
            <option value="+11:00">(GMT +11:00) Magadan, Solomon Islands, New Caledonia</option>
            <option value="+11:50">(GMT +11:30) Norfolk Island</option>
            <option value="+12:00">(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka</option>
            <option value="+12:75">(GMT +12:45) Chatham Islands</option>
            <option value="+13:00">(GMT +13:00) Apia, Nukualofa</option>
            <option value="+14:00">(GMT +14:00) Line Islands, Tokelau</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Contract</label>
          <select class="select is-fullwidth" v-model="provider.contract" name="contract" id="contract">
            <option value="0">Supplier</option>
            <option value="1">Direct</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Ticket opening</label>
          <select class="select is-fullwidth" v-model="provider.ticket" name="ticket" id="ticket">
            <option value="1">Site</option>
            <option value="2">E-mail</option>
            <option value="3">Telephone</option>
          </select>
        </p>
        <p class="control is-expanded">
          <label class="label">{{ parseInt(provider.ticket) === 1 ? 'Link' : 'E-mail' }}</label>
          <input :class="{'input': true, 'is-disabled': inProgress}" type="text" name="ticket_access" id="ticket_access" placeholder="" v-model="provider.ticket_access">        
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      provider_id: {
        type: Number
      }
    },
    data () {
      return {
        provider: {
          name: '',
          cnpj: '',
          social_reason: '',
          municipal_inscription: '',
          cep: '',
          city: '',
          cmun: '',
          state: '',
          country: '',
          address: '',
          address_number: '',
          address_complement: '',
          address_neighborhood: '',
          timezone: '',
          contract: 0,
          phone: '',
          active: 0,
          ticket: 1
        },
        cepProgress: true,
        cepLoading: false,
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      cep () {
        this.cepProgress = true
        this.cepLoading = true
        this.context.$http.get(this.context.$store.state.config.apiURL + '/cep/' + this.provider.cep).then((response) => {
          this.inProgress = false
          this.cepProgress = false
          this.cepLoading = false
          this.provider.address = response.body.logradouro
          this.provider.city = response.body.localidade
          this.provider.state = response.body.uf
          this.provider.country = 'Brasil'
          this.provider.address_neighborhood = response.body.bairro
          this.provider.cmun = response.body.ibge
        }, (response) => {
          this.inProgress = false
          this.cepProgress = false
          this.cepLoading = false
          // this.error = response.body.message
        })
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      save () {
        this.$validator.validateAll()
        // if (this.$validator.errorBag.errors.length === 0) {
        this.inProgress = true
        this.error = ''
        this.context.$http.post(this.context.$store.state.config.apiURL + '/providers/' + this.provider_id, this.provider).then((response) => {
          this.inProgress = false
          this.close(false, {ok: true, message: 'The Provider ' + response.body.name + ' was successfully save'})
        }, (response) => {
          this.inProgress = false
          this.error = response.body
        })
        // }
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/providers/' + this.provider_id).then((response) => {
          this.provider = response.body
          document.body.appendChild(this.$el)
        }, (response) => {
        })
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// Provider.vue?5e537691